import styled from 'styled-components';

export const BannerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
  margin: 0em auto;
  width: 100%;
  background-image: url(${(props) => props.imageUrl});
  background-size: cover;
  background-position: center;

  border-radius: 21px;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 90vh;
    width: 100%;
    margin: 0em auto;
    border-radius: 0 0 25px 25px;
    overflow: hidden;
  }
`;

export const TextOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 5em 9em 0;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  text-align: center;
  color: white;

  @media (max-width: 768px) {
    padding: 3em 1em 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
`;

export const Logo = styled.img`
  width: 200px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 150px;
    margin-bottom: 80px;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.2em;
  margin-bottom: 1em;
  font-weight: 400;
  text-align: center;
  color: #016389;

  @media (max-width: 768px) {
    font-size: 1em;
  }
`;

export const Button = styled.button`
  padding: 10px 20px;
  font-size: 1em;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.9em;
  }
`;

export const BtnFixed = styled.div`
  position: absolute;
  bottom: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-size: 25px;
  text-align: center;
  margin: 0;
`;

export const TextImage = styled.img`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 10px;
    width: 90%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: white;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;
